module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo2m.9e1f2da7.png";